<template>
    <div class="form-container">
        <loader :trigger="loading" :message="loaderMessage"></loader>
        <div>
            <h1
                class="title"
                style="
                    text-align: center;
                    margin-bottom: 50px;
                    margin-top: 20px;
                    color: #4952ff !important;
                "
            >
                {{ $t("Invoice Checkout") }}
            </h1>
            <img
                style="height: 300px; width: 100%"
                src="@/assets/images/Checkout.svg"
            />
        </div>
        <div class="columns is-desktop">
            <div class="column right-border">
                <div class="pricing">
                    <p class="section-title">{{ $t("Total Invoice Cost") }}</p>

                    <div class="item total-item no-border">
                        <p class="fee-title">
                            <sub>{{ $t("Total") }}</sub>
                        </p>

                        <div class="total-container">
                            <p class="total-price-SAR">
                                <span>
                                    {{ (dueAmount / 3.75) | currency("") }}
                                </span>

                                <sub style="text-transform: uppercase">
                                    {{ $t("USD") }}
                                </sub>
                            </p>

                            <p class="total-price">
                                <span>
                                    {{ dueAmount | currency("") }}
                                </span>
                                <sub style="text-transform: uppercase">
                                    {{ $t("SAR") }}
                                </sub>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="cards">
                    <p class="section-title">{{ $t("Payment") }}</p>
                    <div class="payment-tabs">
                        <comp-loader v-if="!accessTabs" />
                        <b-tabs position="is-centered" class="block">
                            <b-tab-item class="creditCard">
                                <template #header>
                                    <div class="pay-options">
                                        <div
                                            class="payment-opt active"
                                            @click="getCheckoutId(false)"
                                        >
                                            <img
                                                src="@/assets/images/mada-trs.png"
                                            />
                                        </div>
                                    </div>
                                </template>

                                <div>
                                    <div
                                        class="mada"
                                        v-if="paymentOpt == false"
                                    >
                                        <form
                                            id="mada"
                                            :action="
                                                domain + '/invoice-transaction'
                                            "
                                            class="paymentWidgets"
                                            data-brands="MADA"
                                        ></form>
                                    </div>
                                </div>
                            </b-tab-item>
                            <b-tab-item class="creditCard">
                                <template #header>
                                    <div class="pay-options">
                                        <div
                                            class="payment-opt"
                                            @click="getCheckoutId(true)"
                                        >
                                            <img
                                                style="height: 15px"
                                                src="@/assets/images/visa.png"
                                            />
                                            <img
                                                src="@/assets/images/mastercard.png"
                                            />
                                        </div>
                                    </div>
                                </template>
                                <div>
                                    <div class="visa" v-if="paymentOpt == true">
                                        <form
                                            id="visa"
                                            :action="
                                                domain + '/invoice-transaction'
                                            "
                                            class="paymentWidgets"
                                            data-brands="VISA MASTER"
                                        ></form>
                                    </div>
                                </div>
                            </b-tab-item>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
        <div class="options">
            <button class="back" @click="$router.go(-1)">
                {{ $t("Back") }}
            </button>
            <div>
                <button @click="$router.push('/my-shipment')" class="later">
                    {{ $t("Save order, and pay later") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import compLoader from "@/components/compLoader.vue";

const $ = require("jquery");
window.$ = $;

export default {
    components: {
        Loader,
        compLoader,
    },
    data() {
        return {
            paymentOpt: false,
            loading: false,
            loaderMessage: null,
            scriptTag1: true,
            scriptTag2: true,
            accessTabs: false,
            dueAmount: 0,
        };
    },
    methods: {
        getCheckoutId(option) {
            if (this.paymentOpt == option || !this.scriptTag2) return;
            this.accessTabs = false;
            document.head.removeChild(this.scriptTag1);
            document.head.removeChild(this.scriptTag2);
            this.scriptTag1 = false;
            this.scriptTag2 = false;
            this.paymentOpt = option;
            this.$store
                .dispatch("invoiceGetCheckoutId", {
                    id: this.$route.params.id,
                    payment_option: option,
                })
                .then((res) => {
                    let visaOptions = `
                    var wpwlOptions = {
                            locale: '${this.$i18n.locale}',
                            onReady: function() {
                                var createRegistrationHtml = '<div class="customLabel">${this.$t(
                                    "Save payment details?"
                                )}</div><div class="customInput"><input class="visaCheckbox" type="checkbox" name="createRegistration" value="true" /></div>';
                                $('#visa.wpwl-form-card').find('.wpwl-button').before(createRegistrationHtml);
                            },
                            billingAddress: {
                                country: '{res.address.country.iso}',
                                state: '${
                                    res.address.state ? res.address.state : ""
                                }',
                                city: '${res.address.city}',
                                postcode: '${res.address.postal_code}',
                                street1: '${res.address.address_one}',
                                street2: '${res.address.address_two}',
                            },
                            mandatoryBillingFields: {
                                country: true,
                                state: true,
                                city: true,
                                postcode: true,
                                street1: true,
                                street2: false,
                            },
                        }
                    `;

                    let madaOptions = `
                        var wpwlOptions = {
                            style:"card",
                            locale: '${this.$i18n.locale}',
                            onReady: function() {
                                var createRegistrationHtml = '<div class="customLabel">${this.$t(
                                    "Save payment details?"
                                )}</div><div class="customInput"><input class="visaCheckbox" type="checkbox" name="createRegistration" value="true" /></div>';
                                $('#mada.wpwl-form-card').find('.wpwl-button').before(createRegistrationHtml);
                            },
                        }
            `;
                    let recaptchaScript = document.createElement("script");
                    let options = document.createElement("script");
                    recaptchaScript.setAttribute(
                        "src",
                        `https://${
                            process.env.VUE_APP_NODE_ENV === "production"
                                ? ""
                                : "test."
                        }oppwa.com/v1/paymentWidgets.js?checkoutId=${
                            res.payment_details.id
                        }`
                    );

                    options.type = "text/javascript";
                    options.innerHTML = option ? visaOptions : madaOptions;
                    this.scriptTag1 = document.head.appendChild(options);
                    this.scriptTag2 = document.head.appendChild(
                        recaptchaScript
                    );

                    setTimeout(() => {
                        this.accessTabs = true;
                    }, 4000);
                });
        },
    },
    computed: {
        domain() {
            return window.location.origin;
        },
    },
    created() {
        this.dueAmount = sessionStorage.getItem("invoice_due_amount");
    },
    mounted() {
        this.$store
            .dispatch("invoiceGetCheckoutId", {
                id: this.$route.params.id,
                payment_option: false,
            })
            .then((res) => {
                let recaptchaScript = document.createElement("script");
                let options = document.createElement("script");
                recaptchaScript.setAttribute(
                    "src",
                    `https://${
                        process.env.VUE_APP_NODE_ENV === "production"
                            ? ""
                            : "test."
                    }oppwa.com/v1/paymentWidgets.js?checkoutId=${
                        res.payment_details.id
                    }`
                );

                options.type = "text/javascript";
                options.innerHTML = `
                        var wpwlOptions = {
                            locale: '${this.$i18n.locale}',
                            onReady: function() {
                                var createRegistrationHtml = '<div class="customLabel">${this.$t(
                                    "Save payment details?"
                                )}</div><div class="customInput"><input class="visaCheckbox" type="checkbox" name="createRegistration" value="true" /></div>';
                                $('#mada.wpwl-form-card').find('.wpwl-button').before(createRegistrationHtml);
                            }   
                        }`;
                this.scriptTag1 = document.head.appendChild(options);
                this.scriptTag2 = document.head.appendChild(recaptchaScript);
                setTimeout(() => {
                    this.accessTabs = true;
                }, 4000);
            })
            .catch((error) => {
                this.getCheckoutId();
            });
    },
};
</script>

<style lang="scss" scoped>
.options {
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    button {
        min-width: 100px;
        padding: 0 20px;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        margin-top: 30px;
        cursor: pointer;

        border: none;

        &.later,
        &.back {
            margin: 0 15px;
        }

        &.Pay {
            background: #4952ff;
            color: white;
        }
    }
}

.msg {
    width: 100%;
    background: #f7f7f7;
    border-radius: 10px;
    padding: 30px 10px;
    margin: 10px 0;
    text-align: center;

    .title {
        color: #777 !important;
    }

    img {
        height: 100px;
    }
}

::v-deep {
    .payment-tabs {
        position: relative;
    }
    .cards .payment-tabs .b-tabs {
        width: 100%;
    }
    .mada .wpwl-form-card {
        background-image: linear-gradient(
            315deg,
            #dfa375 0%,
            #c58e7f 74%
        ) !important;
        background-color: #c58e7f !important;
        box-shadow: 1px 1px 4px 0px #777 !important;
        border: none !important;

        input[type="text"],
        input[type="number"],
        input[type="tel"],
        iframe.wpwl-control.wpwl-control-iframe.wpwl-control-cardNumber,
        iframe.wpwl-control.wpwl-control-iframe.wpwl-control-cvv,
        select {
            &:lang(ar) {
                direction: ltr !important;

                &::placeholder {
                    direction: rtl;
                }
            }
        }

        button.wpwl-button.wpwl-button-pay {
            background: #4952ff !important;
            margin-top: 20px;
            width: 100px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            padding: 0;
            border: none;
            color: white;
            border-radius: 5px;
        }
    }
    .visa form.wpwl-form.wpwl-form-card.wpwl-clearfix {
        background: none;
        border: none;
        box-shadow: none;

        input[type="text"],
        input[type="number"],
        input[type="tel"],
        iframe.wpwl-control.wpwl-control-iframe.wpwl-control-cardNumber,
        iframe.wpwl-control.wpwl-control-iframe.wpwl-control-cvv,
        select {
            border: none;
            border-bottom: 2px solid #ddd;
            background: none;
            border-radius: 0;

            &:active,
            &:focus {
                border-color: #4952ff !important;
            }

            direction: ltr !important;
        }

        select.wpwl-control.wpwl-control-brand {
            border: 2px solid #ddd;
            border-radius: 5px;

            &:active,
            &:focus {
                border-color: #4952ff !important;
            }
        }

        button.wpwl-button.wpwl-button-pay {
            background: #4952ff !important;
            margin-top: 20px;
            width: 100px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            padding: 0;
            border: none;
            color: white;
            border-radius: 5px;
        }
    }

    .tabs ul {
        border: none;
        a {
            border-bottom: none;
            position: relative;
            padding: 0;
        }
    }
}

hr {
    border-top: 4px solid #777;
    width: 89%;
    margin: 10px auto;
}

.total-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    flex-flow: column-reverse;
}

.total-price-SAR {
    padding: 0 20px;
    margin: 0px 10px;
    background: #efefefdd;
    font-size: 16px;
    border-radius: 50px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
}

.right-border {
    position: relative;

    &:after {
        content: "";
        border-right: 4px solid #ddd;
        height: 50%;
        position: absolute;
        top: 11em;
        right: -10px;
    }
}

.form-container {
    background-color: white;
    box-shadow: 0 15px 15px 0 rgba(217, 217, 217, 0.3);
    border-radius: 20px;
    margin: 50px 0;
    padding: 1.5rem 1.5rem 3rem 1.5rem;
    box-sizing: inherit;
    transition: 0.4s ease-out;
    opacity: 1;
    text-transform: capitalize;

    .creditCard {
        text-align: left;
    }

    .cards,
    .pricing {
        text-align: center;
    }

    .cards {
        .baredex-credit {
            background-image: linear-gradient(315deg, #dfa375 0%, #c58e7f 74%);
            height: 5.39cm;
            width: 8.56cm;
            border-radius: 15px;
            padding: 25px 15px;
            display: inline-block;

            .credits {
                font-weight: bold;
                color: black;
                font-size: 2.4rem;
            }
        }
    }

    .pricing {
        .btn {
            width: 88%;
            border: none;
            background: #ddd;
        }

        .item {
            display: flex;
            border-bottom: 1px solid #ddd;
            width: 75%;
            margin: auto;

            sub {
                padding: 2px 5px;
            }

            &.no-border {
                border-bottom: none;
            }

            &.total-item {
                width: 100%;
                margin-top: 100px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border: 1px solid #ddd;
                border-radius: 7px;
                padding: 15px;

                .fee-title {
                    sub {
                        font-size: 20px;
                        font-weight: bold;
                    }
                }

                .total-price {
                    white-space: nowrap;
                    width: 100%;

                    span {
                        font-size: 38px;
                        color: #000;
                        font-weight: bold;
                    }
                }
            }

            &.hashed-fee {
                width: 88%;
                padding: 5px 0 10px;

                .fee-title {
                    flex-wrap: wrap;

                    sub {
                        width: 100%;
                        text-align: left;

                        &.hint {
                            background: #efefefdd;
                            color: black;
                            font-size: 11px;
                            border-radius: 50px;
                        }
                    }
                }

                .total-price {
                    span.price {
                        opacity: 0.5;
                        display: flex;
                        justify-content: flex-end;
                        width: 100%;

                        sub {
                            font-size: 12px;
                            display: flex;
                            align-items: center;
                        }
                    }

                    sub {
                        text-align: right;

                        &.hint {
                            width: 100%;
                            background: #ff7977;
                            color: black;
                            font-size: 11px;
                            border-radius: 50px;
                        }
                    }
                }
            }

            &.total-item {
                width: 88%;

                .fee-title {
                    sub {
                        font-size: 20px;
                        font-weight: bold;
                    }
                }

                .total-price {
                    span {
                        font-size: 38px;
                        color: #000;
                        font-weight: bold;
                    }
                }
            }
        }

        .fee-title {
            width: 50%;
            display: flex;
            align-items: center;

            sub {
                font-size: 14px;
                color: #000;
            }
        }

        .total-price {
            width: 50%;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-end;

            span {
                // font-weight: bold;
                font-size: 27px;
                color: #000;
            }
        }
    }

    .section-title {
        font-weight: bold;
        font-size: 1.4rem;
        display: inline-block;
        margin-bottom: 25px;
    }

    #form-title-top {
        margin-bottom: 25px;
        display: inline-block;
        font-weight: bold;
        font-size: 1.1em;
    }

    .step-label,
    .vertical-step {
        display: inline-block;
        height: 100px;
    }

    .vertical-step {
        position: absolute;
        width: 15px;

        div {
            position: relative;
            width: 15px;
            height: 100px;

            .circle,
            .step-line,
            .blink {
                position: absolute;
                background-color: #727cf5;
                display: inline-block;
            }

            .step-line {
                height: 80px;
                width: 2px;
                top: 10px;
                left: 8px;
            }

            .circle {
                height: 8px;
                width: 8px;
                border-radius: 50%;
                left: 1px;
                border: 0.25em solid #fafbfe;
                box-sizing: content-box;
                z-index: 5;
            }

            .circle:first-child {
                top: 4px;
            }

            .circle:last-child {
                bottom: 5px;
            }

            .blink {
                animation-name: blink;
                animation-iteration-count: infinite;
                animation-duration: 2s;
                animation-timing-function: ease-out;
                border-radius: 50%;
                width: 32px;
                height: 32px;
                bottom: -19px;
                left: 9px;
                z-index: 6;
            }
        }
    }

    .step-label {
        position: relative;
        min-width: 50px;

        p {
            display: inline-block;
            position: absolute;
        }

        p:first-child {
            top: 0;
        }

        p:last-child {
            bottom: 0;
        }

        &:first-child {
            min-width: 50px;
        }

        &:last-child {
            min-width: 200px;
            margin-left: 28px;
        }
    }
}

.hide-form-container {
    opacity: 0;
}

.addCredit {
    padding: 7px 11px;
    margin: 30px 10px;
    font-size: 14px;
    background: #efefefdd;
    font-size: 16px;
    border-radius: 50px;
    font-weight: bold;
    text-align: center !important;

    a {
        margin: 0 10px;
        text-decoration: underline;
    }
}

.pay-options {
    display: flex;
    margin-bottom: 10px;
    .payment-opt {
        margin: 5px;
        cursor: pointer;
        display: flex;
        align-items: center;
        border: 1px solid #ddd;
        background: white;
        border-radius: 5px;
        padding: 10px 30px;
        img {
            height: 20px;
            -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
            filter: grayscale(100%);
            opacity: 0.65;
        }
    }
}

.is-active {
    img {
        -webkit-filter: grayscale(0%) !important; /* Safari 6.0 - 9.0 */
        filter: grayscale(0%) !important;
        opacity: 1 !important;
    }
}

// .form-msg {
//     text-align: center;
//     font-size: 30px;
//     margin-top: 70px;
//     color: #777;
// }

@keyframes blink {
    0% {
        transform: translate(-50%, -50%) scale(0);
        opacity: 1;
    }

    100% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0;
    }
}

@media screen and (max-width: 700px) {
    .form-container {
        padding: 30px 0 !important;
    }

    .item {
        width: 90% !important;
    }
}
</style>
